<template>
  <app-logged id="ResponsaveisUpdate">
    <v-flex
      :sm6="!!responsavelDoCliente.id"
      xs12
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            :class-widget="(!!responsavelDoCliente.id) ? 'xs12' : 'md6 offset-md3 sm8 offset-sm2 xs12'"
          >
            <div slot="widget-content">
              <validation-provider
                name="número do cpf"
                rules="required|max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  outlined
                  v-model="responsavelDoCliente.cpf_numero"
                  label="CPF"
                  v-mask="`###.###.###-##`"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="nome"
                rules="required|max:255"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="responsavelDoCliente.nome"
                  label="Nome completo"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="Relação com o cliente"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="responsavelDoCliente.relacao"
                  label="Relação"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="responsavelDoCliente.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
    <v-flex
      v-if="!!responsavelDoCliente.id"
      sm6
      xs12
    >
      <app-lista-telefone
        class="mb-4"
      />
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppListaTelefone from '@/components/AppListaTelefone'
import AppButton from '@/components/AppButton'
export default {
  name: 'ResponsaveisUpdate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppListaTelefone,
    AppButton
  },
  computed: {
    ...mapGetters(['responsavelDoCliente'])
  },
  methods: {
    ...mapActions(['postSaveResponsavelDoCliente', 'deleteResponsavelDoCliente']),
    goToClienteUpdate () {
      this.$router.push({
        name: 'clientes-update',
        params: {
          id: this.responsavelDoCliente.cliente_id
        }
      })
    },
    remove () {
      if (confirm('Confirme a exclusão deste responsável.')) {
        this.deleteResponsavelDoCliente().then(res => {
          this.goToClienteUpdate()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveResponsavelDoCliente().then(res => {
            this.goToClienteUpdate()
          })
        }
      })
    }
  }
}
</script>
